module.exports = __webpack_public_path__ + "sun.svg?8813f6dd77639e7bde89ba93151b8b6e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sun.svg
// module id = 152
// module chunks = 0